import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getReplyToEmail = {
  name: "getReplyToEmail" as const,
  input: z.object({ conversationId: zExt.objectId() }),
  output: z.object({
    success: z.boolean(),
    errorMessage: z.string().optional(),
    address: z.string().optional(),
    name: z.string().optional(),
  }),
};
